import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getDutyRoles = async (token, municipalityId, params) => {
  const url = `municipalities/${municipalityId}/duty_roles`
  const data = await apiGet({ url, token, params })
  return data
}

export default function useDutyRoles({ options, params }) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const queryFn = () => getDutyRoles(token, municipality_id, params)
  const queryKey = ['duty_roles', params]
  return useQuery(queryKey, queryFn, {
    ...options
  })
}
